;(async () => {
  if (customElements.get('product-form')) {
    return
  }

  const storeModuleURL = window.__GLOBAL__.assets.store
  const module = await import(storeModuleURL)
  const store = module.default

  class ProductForm extends HTMLElement {
    constructor() {
      super()

      this.form = this.querySelector('form')
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this))

      this.validateRecurateProducts();
    }

    async validateRecurateProducts() {
      const troveCoreConfigElem = document.querySelector('.r-core-config');
      const troveConfig = troveCoreConfigElem ? JSON.parse(troveCoreConfigElem.textContent) : null;
      const preOwnedButton = this.querySelector('.rec-buy-used-button');

      if(troveConfig && preOwnedButton) {
        const usedDataFetch = await fetch(troveConfig.app_proxy_path + '/buyer/product-lookup/' + preOwnedButton.dataset.productId);
        const usedData = await usedDataFetch.json();

        if(!usedData.errors && usedData.data?.count > 0) {
          preOwnedButton.style.display = "flex";
          preOwnedButton.href = usedData.data.product_handle
        } else {
          preOwnedButton.style.display = "none";
        }
      }
    }

    onSubmitHandler(event) {
      event.preventDefault()

      const id = this.querySelector('[name="id"]').value
      const quantity = parseInt(this.querySelector('[name="quantity"]').value)

      let estimatedShipping = this.querySelector('#estimated-shipping')
      if(estimatedShipping && estimatedShipping.value != '') {
        estimatedShipping = estimatedShipping.value
      } else {
        estimatedShipping = false
      }


      let embroideryProduct = document.querySelector('#embroideryProduct')
      if(embroideryProduct && embroideryProduct.value != '') {
        embroideryProduct = embroideryProduct.value
      } else {
        embroideryProduct = false
      }

      let embroideryPlacementOptions = document.querySelector('#embroideryPlacementOptions')
      if(embroideryPlacementOptions && embroideryPlacementOptions.value != '') {
        embroideryPlacementOptions = embroideryPlacementOptions.value
      } else {
        embroideryPlacementOptions = false
      }

      let embroideryPlacementType = document.querySelector('#embroideryPlacementType')
      if(embroideryPlacementType && embroideryPlacementType.value != '') {
        embroideryPlacementType = embroideryPlacementType.value
      } else {
        embroideryPlacementType = false
      }

      let embroideryGraphic = document.querySelector('#embroideryGraphic')
      if(embroideryGraphic && embroideryGraphic.value != '') {
        embroideryGraphic = embroideryGraphic.value
      } else {
        embroideryGraphic = false
      }

      let embroideryCustomLettering = document.querySelector('#embroideryCustomLettering')
      if(embroideryCustomLettering && embroideryCustomLettering.value != '') {
        embroideryCustomLettering = embroideryCustomLettering.value
      } else {
        embroideryCustomLettering = false
      }

      let embroideryFont = document.querySelector('#embroideryFont')
      if(embroideryFont && embroideryFont.value != '') {
        embroideryFont = embroideryFont.value
      } else {
        embroideryFont = false
      }

      let embroideryThreadColor = document.querySelector('#embroideryThreadColor')
      if(embroideryThreadColor && embroideryThreadColor.value != '') {
        embroideryThreadColor = embroideryThreadColor.value
      } else {
        embroideryThreadColor = false
      }

      store.dispatch('addItems', {
        [id]: {
          quantity,
          embroideryProduct,
          embroideryProductID,
          estimatedShipping,
          embroideryPlacementOptions,
          embroideryPlacementType,
          embroideryGraphic,
          embroideryCustomLettering,
          embroideryFont,
          embroideryThreadColor
        }
      }, true)
    }
  }

  customElements.define('product-form', ProductForm)
})()